import extend from 'node.extend';
import util from './util';
const TIMEOUT = 5000;
class Duration {
    constructor({reporter, router}) {
        this.reporter = reporter;
        this.startTime = null;
        this.timer = null;
        this.routerProperties = {};
        this.init(router);
    }
    init(router) {
        if (router && router.afterEach) {
            router.afterEach(to => {
                if (this.timer) {
                    this.report(Date.parse(new Date()) / 1000);
                }
                this.claerTimer();
                this.routerProperties = to.meta.durationProperties || {};
                this.getStartTime();
                if (this.shouldReport()) {
                    this.heartbeatReport();
                }
            });
        } else {
            // onload记录开始时间
            window.onload = () => {
                this.claerTimer();
                this.getStartTime();
                if (this.shouldReport()) {
                    this.heartbeatReport();
                }
            };
        }
        this.handleEvent();
    }
    handleEvent() {
        // unload时上报停留时长
        // ios通过pagehide监听页面卸载
        window.onpagehide = () => {
            this.claerTimer();
            this.report(Date.parse(new Date()) / 1000);
        };

        window.onunload = () => {
            this.claerTimer();
            this.report(Date.parse(new Date()) / 1000);
        };
        // app内处理app后台切换
        if (util.isMamaApp && window.Mama) {
            window._appEnterCallbacks = window._appEnterCallbacks || [];
            window._appLeaveCallbacks = window._appLeaveCallbacks || [];
            window._appEnterCallbacks.push(this.enterCallback.bind(this));
            window._appLeaveCallbacks.push(this.leaveCallback.bind(this));
            window.Mama.onAppEnter = () => {
                window._appEnterCallbacks.map(cb => {
                    cb();
                });
            };
            window.Mama.onAppLeave = () => {
                window._appLeaveCallbacks.map(cb => {
                    cb();
                });
            };
        } else {
            document.addEventListener('visibilitychange', () => {
                if (document.visibilityState === 'visible') {
                    this.enterCallback();
                } else {
                    this.leaveCallback();
                }
            });
        }
    }
    // 上报的判断条件
    shouldReport() {
        return Boolean(
            this.reporter.durationProperties.position &&
                this.reporter.durationProperties.item_type &&
                this.reporter.durationReport
        );
    }
    enterCallback() {
        if (!this.shouldReport()) {
            return;
        }
        this.getStartTime();
        this.claerTimer();
        this.heartbeatReport();
    }
    leaveCallback() {
        if (!this.shouldReport()) {
            return;
        }
        this.claerTimer();
        this.report(Date.parse(new Date()) / 1000);
    }
    // 重新触发上报
    tiggerReport() {
        this.claerTimer();
        this.getStartTime();
        this.heartbeatReport();
    }
    getStartTime() {
        this.startTime = Date.parse(new Date()) / 1000;
    }
    report(endTime) {
        // console.log('endtime', this.startTime, endTime);
        if (!this.shouldReport()) {
            return;
        }
        const routerItemMark = {...this.routerProperties.item_mark} || {};
        const durationPropertiesItemMark =
            this.reporter.durationProperties && this.reporter.durationProperties.item_mark
                ? {...this.reporter.durationProperties.item_mark}
                : {};
        const itemMark = extend(true, durationPropertiesItemMark, routerItemMark);
        const properties = extend(true, {...this.reporter.durationProperties}, {...this.routerProperties});
        const rData = {properties};
        rData.properties.item_mark = extend(true, itemMark, {
            item_mark_1: this.startTime,
            item_mark_2: endTime
        });
        this.reporter.report('duration', rData);
    }
    claerTimer() {
        window.clearInterval(this.timer);
        this.timer = null;
    }
    heartbeatReport() {
        if (this.timer) {
            return;
        }
        this.timer = setInterval(() => {
            const endTime = Date.parse(new Date()) / 1000;
            this.report(endTime);
        }, TIMEOUT);
    }
}

export default Duration;
